import SiteInfoFooter from './SiteInfoFooter';

// Used to be two visually separate footers (a light APK/legal-links block
// stacked above a dark license/social block) — merged into SiteInfoFooter
// so the page only has one. Kept as a thin wrapper so AppLayout's `Footer`
// import doesn't need to change.
export function Footer() {
  return <SiteInfoFooter />;
}
